module.exports = __webpack_public_path__ + "img/hr-straight-rail-diagonal-right-bottom-metals.62624a1f.png";